module.exports = __webpack_public_path__ + "UX16.png?7ae0f03eea5c5ab0929c632670fe7c8c";


//////////////////
// WEBPACK FOOTER
// ./src/assets/UX16.png
// module id = 65
// module chunks = 0